// 封装window下的HWRJSBridge对象，主要是用于挂载callback函数
window.HWRJSBridge = {};
const HWRJSBridge = {
  /**
   * 含义：初始化 - 手写识别原生组件；
   * 场景：页面刷新、切换题目、提交答案、APP返回、是否支持时，需要重置组件；
   */
  init(params, callback) {
    window.HWRJSBridge.initCallback = (jsonStr) => {
      const json = JSON.parse(jsonStr);
      if (json.success === 0) {
        callback && callback();
      }
    };
    const param = {
      params,
      action: 'HWRecognizer.init',
      callback: 'HWRJSBridge.initCallback',
    };
    try {
      window.ssaiAppJS && window.ssaiAppJS.postMessage(JSON.stringify(param));
    } catch (error) {
      console.log(error, '初始化手写识别异常！');
    }
  },
  /**
   * 含义：展示 - 手写识别原生组件；
   * 场景：当触发某一个填空时，展示手写识别；
   */
  show(params, callback) {
    window.HWRJSBridge.showCallback = (jsonStr) => {
      const json = JSON.parse(jsonStr);
      if (json.success === 0) {
        callback && callback();
      }
    };
    const param = {
      params,
      action: 'HWRecognizer.show',
      callback: 'HWRJSBridge.showCallback',
    };
    try {
      window.ssaiAppJS && window.ssaiAppJS.postMessage(JSON.stringify(param));
    } catch (error) {
      console.log(error, '展示手写识别异常！');
    }
  },
  /**
   * 含义：隐藏 - 手写识别原生组件；
   * 使用场景：在当前题目正常隐藏；
   */
  hide() {
    const param = {
      action: 'HWRecognizer.hide',
      params: {},
      callback: '',
    };
    try {
      window.ssaiAppJS && window.ssaiAppJS.postMessage(JSON.stringify(param));
    } catch (error) {
      console.log(error, '销毁手写识别异常！');
    }
  },
  /**
   * 获取手写识别的内容信息
   * 使用场景：当用户做答案提交时，调用协议上传图片，并返回url等信息；
   */
  getInfos() {
    return new Promise((resolve, reject) => {
      window.HWRJSBridge.getInfoCallback = (jsonStr) => {
        try {
          const json = JSON.parse(jsonStr.replace(/\\/g, '\\\\'));
          const identifyType = json.identifyType || 1;
          // identifyType 1: 云端识别 2: SDK识别
          resolve({ data: json.data || {}, identifyType });
        } catch (error) {
          console.log(error, '识别内容JSON.parse解析异常');
          reject(error);
        }
      };
      const param = {
        action: 'HWRecognizer.getInfos',
        params: {},
        callback: 'HWRJSBridge.getInfoCallback',
      };
      try {
        window.ssaiAppJS && window.ssaiAppJS.postMessage(JSON.stringify(param));
      } catch (error) {
        console.log(error, '获取手写识别信息异常！');
      }
    });
  },
};

export default HWRJSBridge;
